export default {
  signal: 'signals',
  event: 'events',
  stimuli: 'stimuli',
  transformation: 'transformations'
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/occurencesCorrespondenceTable.js